import { typeTransferCashDesksFilters } from "./dTransferCashDesksReducer";

export type typeTransferCashDesksRequestFilters = {
  filters: {
    date?:
      | {
          from: string;
          to: string;
        }
      | {};
    posSnNumber?: string | null;
    from?: string | null;
  };

  sortFilter?: {
    direction: string;
    column: string;
  };
};

export const getTransferCashDesksList = async (payload: {
  filters: typeTransferCashDesksFilters;
}) => {
  const data: typeTransferCashDesksRequestFilters = {
    filters: {},
    sortFilter: {
      direction: "ASC",
      column: "dateCreated",
    },
  };

  if (payload.filters.date) {
    data.filters.date! = payload.filters.date;
  }

  try {
    return {
      status: 200,
      data: [
        {
          id: "1111111",
          date: "2022-02-16T16:44:18.162+00:00",

          posSnNumber: "11224456",
          status: "выдан",
          to: {
            id: "userId2",
            name: "userName2",
          },

          whoDidIt: {
            id: "userIf3",
            name: "userName3",
            position: "MANAGER",
          },
        },
        {
          id: "111122",
          date: "2022-02-16T16:44:18.162+00:00",

          posSnNumber: "11224456222",
          status: "возвращен",
          to: {
            id: "userId2",
            name: "userName2",
          },

          whoDidIt: {
            id: "userIf3",
            name: "userName3",
            position: "MANAGER",
          },
        },
      ],
    };
    // eslint-disable-next-line no-unreachable
  } catch (error) {
    return error;
  }
};
